import React from 'react';

const SvgQuestionMarkIcon = (props) => (
  <svg
    viewBox="0 0 10 10"
    width="1em"
    height="1em"
    {...props}
    id="QuestionMarkIcon">
    <path
      d="M5.03.1C2.33.1.13 2.3.13 5s2.2 4.9 4.9 4.9 4.9-2.2 4.9-4.9S7.73.1 5.03.1zm.5 8.65c-.04.09-.09.17-.16.24s-.16.12-.25.16c-.09.03-.19.05-.3.05a.73.73 0 01-.3-.06.608.608 0 01-.24-.15.596.596 0 01-.16-.24.815.815 0 010-.61c.04-.09.1-.17.16-.24s.15-.12.24-.16a.73.73 0 01.3-.06c.1 0 .2.02.29.06.1.04.19.09.26.15s.13.15.16.24c.04.09.06.19.06.3s-.02.22-.06.32zm1.13-4.58c-.16.17-.33.33-.53.49-.2.16-.38.32-.55.49-.17.17-.32.35-.43.56-.12.2-.18.43-.18.69 0 .05 0 .11.01.18.01.07.01.14.02.21a.87.87 0 01-.19.05c-.07.01-.13.01-.2.01-.05-.23-.08-.45-.08-.65 0-.19.02-.37.07-.52.05-.16.11-.3.19-.42.07-.13.16-.25.25-.36.09-.11.19-.21.29-.31.11-.13.22-.25.32-.37s.19-.25.26-.38c.07-.14.13-.29.17-.45.04-.16.06-.35.06-.57 0-.25-.03-.47-.09-.64-.06-.18-.14-.32-.25-.43s-.23-.19-.38-.24c-.15-.05-.32-.08-.5-.08-.22 0-.43.04-.63.11s-.35.18-.48.33c.11.11.19.23.25.36.06.13.09.26.09.39 0 .09-.02.17-.05.25s-.07.13-.13.19-.13.1-.2.13c-.08.03-.17.04-.26.04-.08 0-.17-.01-.24-.04s-.15-.07-.21-.12a.623.623 0 01-.15-.21.653.653 0 01-.06-.29c0-.17.05-.34.14-.53.09-.19.23-.36.42-.51s.41-.28.69-.39c.27-.1.59-.16.94-.16s.66.05.93.16c.27.1.5.24.69.41.19.17.33.37.42.59.1.22.14.45.14.69.01.48-.18.93-.56 1.34z"
      fill="currentColor"
    />
  </svg>
);

export default SvgQuestionMarkIcon;
